import React from 'react'
import { useState } from 'react'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { Box, FormHelperText, IconButton, InputAdornment, TextField } from '@mui/material'

type FormInputProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  name: string
  label: string
  value: string
  error?: null | string
  type?: string
  required?: boolean
  maxLength?: number
}

function FormInput({ onChange, name, label, value, error = null, type, required, maxLength }: FormInputProps) {
  const [showPassword, setShowPassword] = useState(false)
  const inputType = type ? type : 'text'

  const inputProps =
    inputType === 'password'
      ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }
      : {}

  return (
    <Box sx={{ pt: 1.3, pb: 1.3 }}>
      <TextField
        required={required}
        type={inputType === 'password' && showPassword ? 'text' : inputType}
        id={name}
        label={label}
        name={name}
        value={value}
        fullWidth
        error={Boolean(error)}
        onChange={onChange}
        slotProps={{ input: inputProps, inputLabel: { shrink: true }, htmlInput: maxLength ? { maxLength } : undefined }}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  )
}

export default FormInput
